import { getApiUrl } from './configService';
import { authGet, authPatch, authDelete } from './apiService';

const BASE = '/api/workstream-ideas';

/** Public calls use plain fetch with credentials omitted, so no session ever reaches the anonymous endpoints. */
const publicRequest = async (path, init = {}) => {
  const base = await getApiUrl();
  const res = await fetch(`${base}${path}`, {
    ...init,
    credentials: 'omit',
    headers: { 'Content-Type': 'application/json' },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const error = new Error(body.message || `Request failed (${res.status})`);
    error.status = res.status;
    throw error;
  }
  return body.data;
};

/** { categories, impactTypes, statuses, priorities, limits } */
export const getIdeaOptions = () => publicRequest(`${BASE}/options`);

/** Public form submit. `website` is the honeypot field and must stay empty. */
export const submitIdea = (idea) =>
  publicRequest(BASE, { method: 'POST', body: JSON.stringify(idea) });

/** { data: [idea], truncated } newest first */
export const listIdeas = async () => authGet(BASE, null, 'json', { useCache: false });

/** Admin triage: any of status, priority, targetQuarter, owner, triageNotes, linkedAdoItem. Returns the updated idea. */
export const triageIdea = async (id, patch) => (await authPatch(`${BASE}/${encodeURIComponent(id)}`, patch)).data;

export const deleteIdea = (id) => authDelete(`${BASE}/${encodeURIComponent(id)}`);

export const PUBLIC_IDEA_PATH = '/workstream-ideas/new';
